var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCardMirIcon = function SvgCreditCardMirIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#credit-card-mir-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DCEFDC",
    d: "M0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#credit-card-mir-icon_svg__b)",
    d: "M19.944 5.103h-3.85c.224 1.27 1.457 2.467 2.803 2.467h3.066C22 7.458 22 7.271 22 7.16a2.074 2.074 0 0 0-2.056-2.056"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4FAD50",
    d: "M16.43 7.794v3.103h1.87V9.252h1.644c.897 0 1.682-.635 1.944-1.458zM9.85 5.103v5.757h1.645s.411 0 .636-.411a602 602 0 0 0 1.458-2.879h.224v3.29h1.87V5.103h-1.646s-.411.037-.635.411c-.935 1.907-1.458 2.879-1.458 2.879h-.225v-3.29zM2 10.897V5.14h1.87s.523 0 .822.823c.747 2.168.822 2.467.822 2.467s.15-.524.822-2.467c.3-.823.823-.823.823-.823h1.869v5.757h-1.87V7.794h-.223l-1.047 3.103h-.823L4.02 7.794h-.225v3.103z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "credit-card-mir-icon_svg__b",
    x1: 16.087,
    x2: 21.987,
    y1: 6.354,
    y2: 6.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27B1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#148ACA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "credit-card-mir-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
};
export default SvgCreditCardMirIcon;